import windowLevelPresets from './windowLevelPresets';

/*
 * Supported Keys: https://craig.is/killing/mice
 */
const bindings = [
  {
    commandName: 'invertViewport',
    label: 'Invert Colors',
    keys: ['i'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'WindowLevel' },
    context: 'CORNERSTONE',
    label: 'Window Level',
    keys: ['w'],
    isEditable: true,
  },
  {
    commandName: 'setWindowLevel',
    commandOptions: windowLevelPresets[0],
    label: 'Window Preset 0',
    keys: ['0'],
    isEditable: true,
  },
  {
    commandName: 'setWindowLevel',
    commandOptions: windowLevelPresets[1],
    label: 'Window Preset 1',
    keys: ['1'],
    isEditable: true,
  },
  {
    commandName: 'setWindowLevel',
    commandOptions: windowLevelPresets[2],
    label: 'Window Preset 2',
    keys: ['2'],
    isEditable: true,
  },
  {
    commandName: 'setWindowLevel',
    commandOptions: windowLevelPresets[3],
    label: 'Window Preset 3',
    keys: ['3'],
    isEditable: true,
  },
  {
    commandName: 'setWindowLevel',
    commandOptions: windowLevelPresets[4],
    label: 'Window Preset 4',
    keys: ['4'],
    isEditable: true,
  },
  {
    commandName: 'setWindowLevel',
    commandOptions: windowLevelPresets[5],
    label: 'Window Preset 5',
    keys: ['5'],
    isEditable: true,
  },
  {
    commandName: 'setWindowLevel',
    commandOptions: windowLevelPresets[6],
    label: 'Window Preset 6',
    keys: ['6'],
    isEditable: true,
  },
  {
    commandName: 'setWindowLevel',
    commandOptions: windowLevelPresets[7],
    label: 'Window Preset 7',
    keys: ['7'],
    isEditable: true,
  },
  {
    commandName: 'setWindowLevel',
    commandOptions: windowLevelPresets[8],
    label: 'Window Preset 8',
    keys: ['8'],
    isEditable: true,
  },
  {
    commandName: 'setWindowLevel',
    commandOptions: windowLevelPresets[9],
    label: 'Window Preset 9',
    keys: ['9'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'StackScroll' },
    label: 'Stack Scroll',
    context: 'CORNERSTONE',
    keys: ['s'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'Pan' },
    label: 'Pan',
    context: 'CORNERSTONE',
    keys: ['shift', 's'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'Zoom' },
    context: 'CORNERSTONE',
    label: 'Zoom',
    keys: ['z'],
    isEditable: true,
  },
  {
    commandName: 'rotateViewportCW',
    label: 'Rotate Right',
    keys: ['r'],
    isEditable: true,
  },
  {
    commandName: 'setVRToolActive',
    commandOptions: { toolName: 'VR3DRotate' },
    context: 'CORNERSTONE',
    label: '3D Rotate',
    keys: ['shift', 'r'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'ArrowAnnotate' },
    context: 'CORNERSTONE',
    label: 'Annotation',
    keys: ['a'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'Length' },
    context: 'CORNERSTONE',
    label: 'Length',
    keys: ['d'],
    isEditable: true,
  },
  {
    commandName: 'setVRToolActive',
    commandOptions: { toolName: 'VRFreehandScalpel' },
    context: 'CORNERSTONE',
    label: 'Freehand Scalpel',
    keys: ['c'],
    isEditable: true,
  },
  {
    commandName: 'togglePrint',
    label: 'Print',
    keys: ['alt', 'p'],
    isEditable: true,
  },
  {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'Magnify' },
    context: 'CORNERSTONE',
    label: 'Magnify',
    keys: ['shift', 'z'],
    isEditable: true,
  },
  {
    commandName: 'resetViewport',
    label: 'Reset View',
    context: 'CORNERSTONE',
    keys: ['space'],
    isEditable: true,
  },

  {
    commandName: 'showPatientInfo',
    label: 'Patient Information',
    context: 'CORNERSTONE',
    keys: ['h'],
    isEditable: true,
  },
  {
    commandName: 'scaleUpViewport',
    context: 'CORNERSTONE',
    label: 'Zoom In',
    keys: ['+'],
  },
  {
    commandName: 'scaleDownViewport',
    context: 'CORNERSTONE',
    label: 'Zoom Out',
    keys: ['-'],
  },
  {
    commandName: 'fitViewportToWindow',
    context: 'CORNERSTONE',
    label: 'Zoom to Fit',
    keys: ['='],
  },

  /* {
    commandName: 'rotateViewportCCW',
    context: 'CORNERSTONE',
    label: 'Rotate Left',
    keys: ['l'],
  },
   {
    commandName: 'flipViewportHorizontal',
    label: 'Flip Horizontally',
    keys: ['h'],
    isEditable: true,
  },
  {
    commandName: 'flipViewportVertical',
    label: 'Flip Vertically',
    keys: ['v'],
    isEditable: true,
  },
  {
    commandName: 'toggleCine',
    label: 'Cine',
    keys: ['c'],
  }, */

  {
    commandName: 'incrementActiveViewport',
    label: 'Next Image Viewport',
    keys: ['right'],
  },
  {
    commandName: 'decrementActiveViewport',
    label: 'Previous Image Viewport',
    keys: ['left'],
  },
  // {
  //   commandName: 'nextViewportDisplaySet',
  //   label: 'Next Series',
  //   keys: ['pageup'],
  //   isEditable: true,
  // },
  // {
  //   commandName: 'previousViewportDisplaySet',
  //   label: 'Previous Series',
  //   keys: ['pagedown'],
  //   isEditable: true,
  // },
  {
    commandName: 'nextImage',
    label: 'Next Image',
    keys: ['down'],
  },
  {
    commandName: 'previousImage',
    label: 'Previous Image',
    keys: ['up'],
  },
  {
    commandName: 'firstImage',
    label: 'First Image',
    keys: ['home'],
  },
  {
    commandName: 'lastImage',
    label: 'Last Image',
    keys: ['end'],
  },
  /* {
    commandName: 'cancelMeasurement',
    label: 'Cancel Cornerstone Measurement',
    keys: ['esc'],
  }, */
];

export default bindings;
